import React from 'react';
import { useTooltip } from '../../../../../components/hooks/useTooltip';
import { Tooltip } from '../../Tooltip/Tooltip';

type AddToTeamIconProps = {
  onClick?: () => void;
};

export const AddToTeamIcon: React.FC<AddToTeamIconProps> = ({
  onClick,
}: AddToTeamIconProps): JSX.Element => {
  const { handleToggleTooltip, open } = useTooltip();
  return (
    <div onClick={onClick} className="table__icon">
      <Tooltip open={open} text="Add users to the team" />
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="table__icon__icon"
        onMouseEnter={handleToggleTooltip}
        onMouseLeave={handleToggleTooltip}
      >
        <path
          d="M14 14.9676C14 13.6789 15.0447 12.6343 16.3333 12.6343H19.6666C20.9553 12.6343 22 13.6789 22 14.9676C22 15.1517 21.8507 15.3009 21.6666 15.3009H14.3333C14.1492 15.3009 14 15.1517 14 14.9676Z"
          stroke="#394577"
          strokeWidth="2"
        />
        <circle
          cx="17.9999"
          cy="8.63446"
          r="1.69989"
          stroke="#394577"
          strokeWidth="2"
        />
        <path
          d="M2 14.9676C2 13.6789 3.04466 12.6343 4.33332 12.6343H7.66665C8.95531 12.6343 9.99997 13.6789 9.99997 14.9676C9.99997 15.1517 9.85074 15.3009 9.66664 15.3009H2.33333C2.14924 15.3009 2 15.1517 2 14.9676Z"
          stroke="#394577"
          strokeWidth="2"
        />
        <circle
          cx="5.99994"
          cy="8.63446"
          r="1.69989"
          stroke="#394577"
          strokeWidth="2"
        />
        <path
          d="M8 16.7318C8 15.4431 9.04466 14.3984 10.3333 14.3984H13.6666C14.9553 14.3984 16 15.4431 16 16.7318C16 16.9159 15.8507 17.0651 15.6666 17.0651H8.33333C8.14924 17.0651 8 16.9159 8 16.7318Z"
          fill="white"
          stroke="#394577"
          strokeWidth="2"
        />
        <circle
          cx="11.9999"
          cy="10.3986"
          r="1.69989"
          stroke="#394577"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};
